export default "__VITE_PUBLIC_ASSET__faf1b4f4__"